import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';

@Component({
  selector: 'ae-bind-info',
  templateUrl: './bind-info.component.html',
  styleUrls: ['./bind-info.component.scss']
})
export class BindInfoComponent implements OnInit {
  constructor(private router: Router, private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loaderService.hide();
    window.scrollTo(0, 0);
  }
}
